import React from 'react'
import styled from 'styled-components'
import Header from '../component/Header'

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: start;
  align-items: ${props => props.align};
  background-color: ${props => props.theme.global.colors.baseBackground};
`
// const HeaderBox = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-self: stretch;
// `
// let initGrommet = false
const Main = ({ align = 'center', children }) => {
  // const { value: darkMode } = useDarkMode()
  // const tempTheme = { ...theme } //shallow copy no problem, just want to change the shallow address
  // if (darkMode) {
  //   tempTheme.global.colors.brand = '#afa939'
  // }
  // const [customTheme, setCustomTheme] = useState(tempTheme)

  // useEffect(() => {
  //   if (initGrommet) {
  //     const tempTheme = { ...theme } //shallow copy no problem, just want to change the shallow address
  //     if (!darkMode) {
  //       tempTheme.global.colors.brand = '#2b580c'
  //     } else {
  //       tempTheme.global.colors.brand = '#afa939'
  //     }
  //     setCustomTheme(tempTheme)
  //   } else {
  //     initGrommet = true
  //   }
  // }, [darkMode])
  return (
    // <Grommet
    //   theme={customTheme}
    //   // themeMode={darkMode ? 'dark' : 'light'}
    //   background="baseBackground"
    // >
    // <GeneralModal>
    <ContentBox align={align}>
      <Header />

      {children}
    </ContentBox>
    // </GeneralModal>
    // </Grommet>
  )
}

export default Main
